/**
 * Keeps a numeric value within an inclusive range.
 *
 * @param value Number to clamp.
 * @param minimum Minimum allowed value.
 * @param maximum Maximum allowed value.
 * @returns Value constrained to the provided range.
 */
// eslint-disable-next-line import/prefer-default-export
export function clamp(
	value: number,
	minimum: number,
	maximum: number,
): number {
	return Math.min(
		maximum,
		Math.max(
			minimum,
			value,
		),
	);
}
